import {
	OfferActionField,
	OfferConditionField,
	OfferErrorKey,
	OfferField,
	OfferGroupField,
	OfferRuleField,
} from "../constants";
import { isTermsBlockComplete } from "./offerDisplay";

/** Validates the Basic Information wizard step. */
export const validateBasicStep = (draft) => {
	const errors = {};
	if (!draft[OfferField.TITLE]?.trim()) errors[OfferField.TITLE] = "Title is required";
	if (!draft[OfferField.OFFER_CODE]?.trim())
		errors[OfferField.OFFER_CODE] = "Offer code is required";
	if (!draft[OfferField.OFFER_TYPE]) errors[OfferField.OFFER_TYPE] = "Offer type is required";
	if (!draft[OfferField.SUB_OFFER_TYPE])
		errors[OfferField.SUB_OFFER_TYPE] = "Sub offer type is required";
	if (!draft[OfferField.OFFER_GROUP_ID])
		errors[OfferField.OFFER_GROUP_ID] = "Offer group is required";
	if (
		draft[OfferField.PRIORITY] === "" ||
		draft[OfferField.PRIORITY] === null ||
		draft[OfferField.PRIORITY] === undefined
	) {
		errors[OfferField.PRIORITY] = "Priority is required";
	}
	if (!draft[OfferField.CHANNEL]) errors[OfferField.CHANNEL] = "Channel is required";
	if (!draft[OfferField.START_DATE]) errors[OfferField.START_DATE] = "Start date is required";
	if (!draft[OfferField.END_DATE]) errors[OfferField.END_DATE] = "End date is required";
	if (
		draft[OfferField.START_DATE] &&
		draft[OfferField.END_DATE] &&
		new Date(draft[OfferField.END_DATE]) < new Date(draft[OfferField.START_DATE])
	) {
		errors[OfferField.END_DATE] = "End date must be after start date";
	}
	if (
		draft[OfferField.MAX_USAGE_COUNT] === "" ||
		draft[OfferField.MAX_USAGE_COUNT] === null ||
		draft[OfferField.MAX_USAGE_COUNT] === undefined
	) {
		errors[OfferField.MAX_USAGE_COUNT] = "Max usage count is required";
	}
	if (
		draft[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] === "" ||
		draft[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] === null ||
		draft[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] === undefined
	) {
		errors[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] = "Individual max usage is required";
	}

	if (draft[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] > draft[OfferField.MAX_USAGE_COUNT])
		errors[OfferField.INDIVIDUAL_MAX_USAGE_COUNT] =
			"Individual max usage count must be less than or equal to max usage count";

	return errors;
};

/** Validates the Rules & Action wizard step. */
export const validateRulesStep = (draft) => {
	const errors = {};
	const rule = draft[OfferField.RULE] || {};
	if (!rule[OfferRuleField.DESCRIPTION]?.trim()) {
		errors[OfferErrorKey.RULE_DESCRIPTION] = "Rule description is required";
	}

	const conditions = rule[OfferRuleField.CONDITIONS] || [];
	const hasValidCondition = conditions.some(
		(c) =>
			c[OfferConditionField.SUBJECT] &&
			c[OfferConditionField.OPERATOR] &&
			c[OfferConditionField.VALUE] !== ""
	);
	if (!hasValidCondition) {
		errors[OfferErrorKey.CONDITIONS] = "At least one complete condition is required";
	}

	const action = rule[OfferRuleField.ACTION] || {};
	if (!action[OfferActionField.TYPE]) {
		errors[OfferErrorKey.ACTION_TYPE] = "Action type is required";
	}
	if (
		action[OfferActionField.VALUE] === "" ||
		action[OfferActionField.VALUE] === null ||
		action[OfferActionField.VALUE] === undefined
	) {
		errors[OfferErrorKey.ACTION_VALUE] = "Action value is required";
	}
	if (!action[OfferActionField.TARGET]) {
		errors[OfferErrorKey.ACTION_TARGET] = "Action target is required";
	}

	return errors;
};

/** Validates the Mapping wizard step. Currently no required fields. */
export const validateMappingStep = (_draft) => {
	return {};
};

/** Validates the Terms & Conditions wizard step. */
export const validateTermsStep = (draft) => {
	const errors = {};
	const terms = draft[OfferField.TERMS_CONDITION] || [];
	if(!terms.length) {
		errors[OfferField.TERMS_CONDITION] = "At least one terms block is required";
	}
	if (terms.some((block) => !isTermsBlockComplete(block))) {
		errors[OfferField.TERMS_CONDITION] = "Each terms block needs a type and non-empty content";
	}
	return errors;
};

/** Validates the Create Offer Group form. */
export const validateOfferGroupForm = (draft) => {
	const errors = {};
	if (!draft[OfferGroupField.NAME]?.trim()) {
		errors[OfferGroupField.NAME] = "Group name is required";
	}
	return errors;
};

/** Builds dropdown options for selecting an offer group. */
export const buildOfferGroupDropdownOptions = (groups) =>
	(groups || []).map((g) => ({
		head: g.name || g._id || g.id,
		value: g._id || g.id,
	}));
